import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import SiteWrapperSuperadminReact from "../SiteWrapper.superadmin.react";
import UploadForm from "./UploadForm";
import ViewUploadedData from "./ViewUploadedData";

function UploadNotification() {
  const [refreshData, setRefreshData] = useState(0);
  return (
    <SiteWrapperSuperadminReact>
      <div className="container">
        <div className="row">
          <div className="col-6">
            <UploadForm onSubmit={() => setRefreshData((prev) => prev + 1)} />
          </div>
          <div className="col-6">
            <ViewUploadedData refreshData={refreshData} />
          </div>
        </div>
      </div>
    </SiteWrapperSuperadminReact>
  );
}

export default withRouter(UploadNotification);
